import { DIFFICULTY_LEVELS, QUESTION_TYPES } from '../questionTypes';

// 30 Preguntas del Músculo Digástrico
// 10 Básicas + 10 Generales + 10 Complejas

export const digastricoQuestions = [
  
  // ========== NIVEL BÁSICO (10) ==========
  
  {
    id: 10271,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Qué significa el nombre 'digástrico'?",
    options: [
      "Dos vientres",
      "Dos orígenes",
      "Dos inserciones",
      "Dos funciones"
    ],
    correctAnswer: 0,
    explanation: "El nombre 'digástrico' significa 'dos vientres' en griego, refiriéndose a sus dos porciones musculares separadas por un tendón intermedio. Tiene vientre anterior (suprahioideo) y vientre posterior (infrahioideo), conectados por un tendón que se fija al hueso hioides."
  },
  
  {
    id: 10272,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.IDENTIFICACION,
    question: "¿Dónde se origina el vientre anterior del digástrico?",
    options: [
      "Fosa digástrica de la mandíbula",
      "Apófisis mastoides",
      "Hueso hioides",
      "Apófisis estiloides"
    ],
    correctAnswer: 0,
    explanation: "El vientre anterior del digástrico se origina en la fosa digástrica de la mandíbula, cerca del sínfisis mentoniana. Esta inserción mandibular permite al músculo deprimir la mandíbula y elevar el hueso hioides durante la deglución."
  },
  
  {
    id: 10273,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Cuál es la función principal del digástrico?",
    options: [
      "Elevación del hueso hioides",
      "Depresión de la mandíbula",
      "Apertura de la boca",
      "Todas las anteriores"
    ],
    correctAnswer: 3,
    explanation: "El digástrico tiene múltiples funciones: eleva el hueso hioides durante la deglución, deprime la mandíbula para abrir la boca, y estabiliza el hioides durante movimientos faríngeos. Es un músculo importante en la coordinación deglución-masticación."
  },
  
  {
    id: 10274,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.INERVACION,
    question: "¿Qué nervios inervan al digástrico?",
    options: [
      "Nervio trigémino (V) para vientre anterior, facial (VII) para posterior",
      "Nervio facial (VII) para vientre anterior, glosofaríngeo (IX) para posterior",
      "Nervio hipogloso (XII) para ambos vientres",
      "Plexo cervical para ambos vientres"
    ],
    correctAnswer: 0,
    explanation: "El vientre anterior del digástrico es inervado por el nervio milohioideo (rama del trigémino V), mientras que el vientre posterior es inervado por el nervio digástrico (rama del facial VII). Esta doble inervación craneal refleja su origen embriológico."
  },
  
  {
    id: 10275,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VASCULARIZACION,
    question: "¿Qué arteria irriga principalmente al digástrico?",
    options: [
      "Arteria lingual",
      "Arteria facial",
      "Arteria occipital",
      "Arteria tiroidea superior"
    ],
    correctAnswer: 1,
    explanation: "La arteria facial irriga principalmente al vientre anterior del digástrico, mientras que el vientre posterior recibe irrigación de la arteria occipital. Esta vascularización refleja la función del músculo en movimientos tanto supra como infrahioideos."
  },
  
  {
    id: 10276,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué estructura pasa por la muesca del digástrico?",
    options: [
      "Arteria carótida externa",
      "Nervio hipogloso",
      "Vena lingual",
      "Conducto de Wharton"
    ],
    correctAnswer: 1,
    explanation: "El nervio hipogloso (XII par craneal) pasa por la muesca del digástrico en el tendón intermedio. Esta relación explica por qué el tendón intermedio del digástrico es un punto de referencia importante en cirugía cervical profunda."
  },
  
  {
    id: 10277,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Qué tipo de músculo es el digástrico?",
    options: [
      "Músculo suprahoideo",
      "Músculo infrahioideo",
      "Músculo hioideo (cruza el hioides)",
      "Músculo mandibular"
    ],
    correctAnswer: 2,
    explanation: "El digástrico es un músculo hioideo porque cruza el hueso hioides con su tendón intermedio. Forma parte del suelo de la boca y del diafragma oral, contribuyendo a la suspensión laríngea durante la deglución."
  },
  
  {
    id: 10278,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.IDENTIFICACION,
    question: "¿Dónde se origina el vientre posterior del digástrico?",
    options: [
      "Apófisis mastoides del temporal",
      "Apófisis estiloides del temporal",
      "Cóndilo occipital",
      "Apófisis transversa de atlas"
    ],
    correctAnswer: 0,
    explanation: "El vientre posterior del digástrico se origina en la incisura mastoidea del hueso temporal, cerca de la apófisis mastoides. Esta inserción temporal permite al músculo actuar como depresor del hioides durante la fase oral de la deglución."
  },
  
  {
    id: 10279,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Qué músculo antagonista del digástrico en la apertura de boca?",
    options: [
      "Masetero",
      "Temporal",
      "Pterigoideos",
      "Todos los anteriores"
    ],
    correctAnswer: 3,
    explanation: "Los antagonistas del digástrico en la apertura de boca son los músculos elevadores de la mandíbula: masetero, temporal y pterigoideos. El equilibrio entre estos grupos musculares permite movimientos coordinados de masticación y deglución."
  },
  
  {
    id: 10280,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Por qué el digástrico es importante en la fonación?",
    options: [
      "Controla la tensión de cuerdas vocales",
      "Estabiliza la laringe",
      "Coordina con constrictores faríngeos",
      "Todas las anteriores"
    ],
    correctAnswer: 1,
    explanation: "El digástrico contribuye a la fonación al estabilizar la laringe durante la producción de sonidos. Su contracción coordinada con otros músculos suprahioideos mantiene la posición laríngea óptima para la resonancia vocal y protección de vías aéreas."
  },
  
  // ========== NIVEL GENERAL (10) ==========
  
  {
    id: 10281,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Cómo contribuye el digástrico a las fases de la deglución?",
    options: [
      "Solo en fase oral",
      "Solo en fase faríngea",
      "En ambas fases",
      "No contribuye a la deglución"
    ],
    correctAnswer: 2,
    explanation: "El digástrico contribuye a ambas fases de la deglución: en la fase oral eleva el hioides para abrir la epiglotis, y en la fase faríngea estabiliza la laringe durante el paso del bolo alimenticio. Es esencial para la protección de vías aéreas."
  },
  
  {
    id: 10282,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué músculos forman el triángulo submandibular junto con el digástrico?",
    options: [
      "Milohioideo y hiogloso",
      "Genihioideo y estilohioideo",
      "Esternohioideo y tirohioideo",
      "Todos los anteriores"
    ],
    correctAnswer: 0,
    explanation: "El triángulo submandibular (de Pirogov) está formado por el vientre anterior del digástrico, el borde posterior del milohioideo y el hiogloso. Contiene la glándula submandibular y estructuras vasculonerviosas importantes."
  },
  
  {
    id: 10283,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VASCULARIZACION,
    question: "¿Qué rama específica irriga el vientre posterior del digástrico?",
    options: [
      "Arteria faríngea ascendente",
      "Arteria occipital",
      "Arteria auricular posterior",
      "Arteria temporal superficial"
    ],
    correctAnswer: 1,
    explanation: "La arteria occipital irriga específicamente el vientre posterior del digástrico. Esta arteria emerge del tronco tirocervical y asciende por la región posterior del cuello, proporcionando irrigación a los músculos infrahioideos posteriores."
  },
  
  {
    id: 10284,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.INERVACION,
    question: "¿Cómo se diferencia la inervación de los dos vientres del digástrico?",
    options: [
      "Ambos por nervio trigémino",
      "Ambos por nervio facial",
      "Vientre anterior por V, posterior por VII",
      "Vientre anterior por VII, posterior por IX"
    ],
    correctAnswer: 2,
    explanation: "El vientre anterior es inervado por el nervio milohioideo (rama mandibular del trigémino V), mientras que el vientre posterior recibe el nervio digástrico (rama del facial VII). Esta doble inervación refleja el origen embriológico mixto del músculo."
  },
  
  {
    id: 10285,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VARIANTE,
    question: "¿Cuál es la variante anatómica más común del digástrico?",
    options: [
      "Ausencia del vientre posterior",
      "Tendón intermedio calcificado",
      "Vientre accesorio",
      "Fusión con milohioideo"
    ],
    correctAnswer: 1,
    explanation: "La calcificación del tendón intermedio del digástrico es la variante más común, especialmente en adultos mayores. Puede confundirse con patología en radiografías panorámicas y es más frecuente en el lado derecho."
  },
  
  {
    id: 10286,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "¿Qué test evalúa la función del vientre anterior del digástrico?",
    options: [
      "Test de protrusión lingual",
      "Test de elevación mandibular",
      "Test de depresión mandibular",
      "Test de rotación mandibular"
    ],
    correctAnswer: 2,
    explanation: "El test de depresión mandibular evalúa la función del vientre anterior del digástrico. El paciente abre la boca contra resistencia aplicada en el mentón. Debilidad indica lesión del nervio milohioideo o del vientre anterior del digástrico."
  },
  
  {
    id: 10287,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.EMBRIOLOGIA,
    question: "¿De qué arco faríngeo se desarrolla el digástrico?",
    options: [
      "Primer arco (mandibular)",
      "Segundo arco (hioideo)",
      "Tercer arco",
      "Desarrollo mixto"
    ],
    correctAnswer: 3,
    explanation: "El digástrico tiene desarrollo mixto: el vientre anterior deriva del primer arco faríngeo (mandibular), mientras que el vientre posterior se desarrolla del segundo arco (hioideo). Esta dualidad refleja su función en movimientos tanto mandibulares como hioideos."
  },
  
  {
    id: 10288,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.HISTOLOGIA,
    question: "¿Qué proporción aproximada de fibras musculares tiene el digástrico?",
    options: [
      "90% fibras tipo I",
      "70% fibras tipo II",
      "60% tipo I, 40% tipo II",
      "50% tipo I, 50% tipo II"
    ],
    correctAnswer: 2,
    explanation: "El digástrico tiene predominio de fibras tipo I (60%), adaptadas para funciones posturales y de precisión como la deglución y estabilización mandibular. El equilibrio fibrilar refleja su papel en movimientos finos y sostenidos."
  },
  
  {
    id: 10289,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué fascia cubre al digástrico?",
    options: [
      "Fascia cervical superficial",
      "Fascia cervical media",
      "Aponeurosis cervical profunda",
      "Todas las anteriores"
    ],
    correctAnswer: 3,
    explanation: "El digástrico está cubierto por fascia cervical superficial, media (que forma la vaina carotídea) y aponeurosis cervical profunda. Esta cobertura fascial múltiple proporciona estabilidad y permite el deslizamiento durante movimientos deglutorios."
  },
  
  {
    id: 10290,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Por qué el digástrico es importante en la respiración?",
    options: [
      "Es respiratorio accesorio",
      "Estabiliza la laringe",
      "Previene aspiración",
      "Todas las anteriores"
    ],
    correctAnswer: 2,
    explanation: "El digástrico es importante en la respiración porque previene la aspiración al mantener la laringe elevada durante la inspiración. Su contracción coordinada con otros músculos suprahioideos protege las vías aéreas durante movimientos respiratorios."
  },
  
  // ========== NIVEL COMPLEJO (10) ==========
  
  {
    id: 10291,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CASO_CLINICO,
    question: "Paciente con trismo post-extracción tercer molar. EMG muestra denervación de digástrico anterior. ¿Qué complicación es?",
    options: [
      "Lesión del nervio lingual",
      "Lesión del nervio alveolar inferior",
      "Lesión del nervio milohioideo",
      "Lesión del nervio facial"
    ],
    correctAnswer: 2,
    explanation: "La denervación del vientre anterior del digástrico indica lesión del nervio milohioideo durante cirugía oral. Este nervio es rama del trigémino mandibular y puede lesionarse en extracciones complejas del tercer molar. Causa debilidad en apertura de boca."
  },
  
  {
    id: 10292,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.DIAGNOSTICO,
    question: "Paciente con disfagia y voz nasal. Exploración muestra debilidad de vientre posterior digástrico. ¿Qué nervio está afectado?",
    options: [
      "Nervio trigémino",
      "Nervio facial",
      "Nervio glosofaríngeo",
      "Nervio vago"
    ],
    correctAnswer: 1,
    explanation: "La debilidad del vientre posterior del digástrico indica lesión del nervio facial (rama digástrica). Causa alteración de la deglución por falta de elevación hioidea y voz nasal por incompetencia velofaríngea. Es común en parálisis facial periférica."
  },
  
  {
    id: 10293,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.QUIRURGICA,
    question: "¿Qué abordaje se utiliza para liberación de contractura digástrica congénita?",
    options: [
      "Abordaje intraoral",
      "Abordaje submandibular",
      "Abordaje cervical anterior",
      "Abordaje temporal"
    ],
    correctAnswer: 1,
    explanation: "El abordaje submandibular permite liberación de contractura congénita del digástrico. Se accede al triángulo submandibular para seccionar el vientre anterior fibroso. Es efectivo para corregir tortícolis congénita cuando el tratamiento conservador falla."
  },
  
  {
    id: 10294,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.IMAGENOLOGIA,
    question: "En RM cervical, ¿qué hallazgo confirma ruptura del tendón intermedio del digástrico?",
    options: [
      "Engrosamiento del tendón",
      "Retracción de los vientres musculares",
      "Aumento de señal en T2-STIR",
      "Calcificación tendinosa"
    ],
    correctAnswer: 1,
    explanation: "La ruptura del tendón intermedio del digástrico muestra retracción de los vientres anterior y posterior en RM, con separación visible en el sitio de ruptura. Es rara pero puede ocurrir por trauma directo o degeneración. Requiere reparación quirúrgica."
  },
  
  {
    id: 10295,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "¿Qué complicación puede causar la parálisis del digástrico en la deglución?",
    options: [
      "Disfagia orofaríngea",
      "Aspiración por falta de protección laríngea",
      "Impactación alimentaria",
      "Todas las anteriores"
    ],
    correctAnswer: 1,
    explanation: "La parálisis del digástrico causa aspiración por falta de elevación hioidea y protección laríngea. El hioides no se eleva adecuadamente durante la deglución, permitiendo que el bolo alimenticio entre en vías aéreas. Es una complicación grave en parálisis facial bilateral."
  },
  
  {
    id: 10296,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CASO_CLINICO,
    question: "Paciente con parálisis facial presenta dificultad para comer y beber. ¿Qué componente del digástrico está afectado?",
    options: [
      "Vientre anterior",
      "Vientre posterior",
      "Tendón intermedio",
      "Ambos vientres"
    ],
    correctAnswer: 1,
    explanation: "La dificultad para comer y beber en parálisis facial indica afectación del vientre posterior del digástrico (inervado por nervio facial). El paciente no puede elevar el hioides adecuadamente, causando regurgitación nasal y aspiración. Requiere modificación de dieta y terapia."
  },
  
  {
    id: 10297,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.DIAGNOSTICO,
    question: "Evaluación videofluoroscópica muestra falta de elevación hioidea durante deglución. ¿Qué músculo está afectado?",
    options: [
      "Milohioideo",
      "Genihioideo",
      "Digástrico",
      "Todos los anteriores"
    ],
    correctAnswer: 2,
    explanation: "La falta de elevación hioidea en videofluoroscopia indica afectación del digástrico, principal elevador del hioides. Los demás músculos contribuyen pero el digástrico es esencial. Es útil para diferenciar causas neurológicas de mecánicas en disfagia."
  },
  
  {
    id: 10298,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.QUIRURGICA,
    question: "¿Qué técnica se utiliza para reconstrucción funcional del digástrico paralizado?",
    options: [
      "Transferencia del temporal",
      "Transferencia del milohioideo",
      "Transferencia del genihioideo",
      "Todas las anteriores"
    ],
    correctAnswer: 1,
    explanation: "La transferencia del milohioideo al hioides se utiliza para reconstruir la función del digástrico paralizado. El milohioideo (inervado por trigémino) se transfiere para proporcionar elevación hioidea activa. Es efectivo en parálisis facial bilateral."
  },
  
  {
    id: 10299,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.IMAGENOLOGIA,
    question: "En ecografía cervical, ¿qué maniobra evalúa la contractilidad del digástrico?",
    options: [
      "Depresión mandibular pasiva",
      "Elevación hioidea activa",
      "Apertura de boca contra resistencia",
      "Movimiento de protrusión lingual"
    ],
    correctAnswer: 1,
    explanation: "La ecografía durante elevación hioidea activa evalúa la contractilidad del digástrico. Muestra engrosamiento muscular durante contracción y permite cuantificar la función en casos de sospecha de parálisis. Es no invasiva y puede realizarse a la cabecera del paciente."
  },
  
  {
    id: 10300,
    muscle: 'digastrico',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "Paciente con hipertrofia compensatoria del digástrico contralateral. ¿Qué explica este hallazgo?",
    options: [
      "Parálisis homolateral",
      "Sobrecarga funcional",
      "Adaptación postural",
      "Todas las anteriores"
    ],
    correctAnswer: 3,
    explanation: "La hipertrofia compensatoria del digástrico contralateral ocurre por parálisis homolateral, sobrecarga funcional en movimientos unilaterales y adaptación postural. El músculo contralateral se hipertrofia para compensar la pérdida funcional. Es común en tortícolis congénita."
  }
];
